import config from 'config/config'
import isEqual from 'lodash/isEqual'
import { I18n } from 'lib/i18n'
import { del, get, post, put } from 'lib/utilities'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'
import { arrayPush, change, initialize } from 'redux-form'
import { loadProductState } from 'redux/importer'
import uuid from 'uuid'
import * as categories from './categories'
import { setDirtyFormState } from './navigation'
import { loadProperties } from './properties'

export const INITIALIZE_IMPORT_FORM = 'product/INITIALIZE_IMPORT_FORM'
export const COPY_IMPORT_FORM = 'product/COPY_IMPORT_FORM'

export const INITIALIZE_COMPARE_FORM_DONE =
  'product/INITIALIZE_COMPARE_FORM_DONE'
export const INITIALIZE_DETAIL_FORM = 'product/INITIALIZE_DETAIL_FORM'
export const INITIALIZE_DETAIL_FORM_DONE = 'product/INITIALIZE_DETAIL_FORM_DONE'
export const INITIALIZE_COMPARE_FORM = 'product/INITIALIZE_COMPARE_FORM'
export const INITIALIZE_IMPORT_FORM_DONE = 'product/INITIALIZE_IMPORT_FORM_DONE'

export const CHECK_CATEGORY_PROPERTIES = 'product/CHECK_CATEGORY_PROPERTIES'
export const CREATE_PROPERTY = 'product/CREATE_PROPERTY'
export const CREATE_PROPERTY_DONE = 'product/CREATE_PROPERTY_DONE'
export const CREATE_PROPERTY_FAILED = 'product/CREATE_PROPERTY_FAILED'

export const CREATE_PROPERTY_VALUE = 'product/CREATE_PROPERTY_VALUE'
export const CREATE_PROPERTY_VALUE_DONE = 'product/CREATE_PROPERTY_VALUE_DONE'
export const CREATE_PROPERTY_VALUE_FAILED =
  'product/CREATE_PROPERTY_VALUE_FAILED'

export const LOAD_IMPORT = 'product/LOAD_IMPORT'
export const LOAD_IMPORT_DONE = 'product/LOAD_IMPORT_DONE'
export const LOAD_IMPORT_FAILED = 'product/LOAD_IMPORT_FAILED'

export const CREATE = 'product/CREATE'
export const CREATE_DONE = 'product/CREATE_DONE'
export const CREATE_FAILED = 'product/CREATE_FAILED'

export const CREATE_FAMILY = 'product/CREATE_FAMILY'
export const CREATE_FAMILY_DONE = 'product/CREATE_FAMILY_DONE'
export const CREATE_FAMILY_FAILED = 'product/CREATE_FAMILY_FAILED'

export const LOAD = 'product/LOAD'
export const CLEAR = 'product/CLEAR'
export const LOAD_DONE = 'product/LOAD_DONE'
export const LOAD_FAILED = 'product/LOAD_FAILED'

export const LOAD_SHOP_PRODUCTS = 'product/LOAD_SHOP_PRODUCTS'
export const LOAD_SHOP_PRODUCTS_FULFILLED =
  'product/LOAD_SHOP_PRODUCTS_FULFILLED'

export const SAVE = 'product/SAVE'
export const SAVE_DONE = 'product/SAVE_DONE'
export const SAVE_FAILED = 'product/SAVE_FAILED'

export const DELETE = 'product/DELETE'
export const DELETE_DONE = 'product/DELETE_DONE'
export const DELETE_FAILED = 'product/DELETE_FAILED'

export const DISABLE_FORM = 'product/DISABLE_FORM'
export const LOAD_PRODUCTS = 'product/LOAD_PRODUCTS'
export const LOAD_PRODUCTS_DONE = 'product/LOAD_PRODUCTS_DONE'
export const LOAD_PRODUCTS_FAILED = 'product/LOAD_PRODUCTS_FAILED'
export const SET_PROPERTIES = 'product/SET_PROPERTIES'

export const UPDATE_ALL = 'product/UPDATE_ALL'
export const UPDATE_ALL_DONE = 'product/UPDATE_ALL_DONE'
export const UPDATE_ALL_FAILED = 'product/UPDATE_ALL_FAILED'

export const ARCHIVE_ALL = 'product/ARCHIVE_ALL'
export const ARCHIVE_ALL_DONE = 'product/ARCHIVE_ALL_DONE'
export const ARCHIVE_ALL_FAILED = 'product/ARCHIVE_ALL_FAILED'

// action creators
export const initializeImportForm = (article_number) => ({
  type: INITIALIZE_IMPORT_FORM,
  article_number,
})
export const copyImportForm = (article_number) => ({
  type: COPY_IMPORT_FORM,
  article_number,
})
export const initializeDetailForm = (article_number) => ({
  type: INITIALIZE_DETAIL_FORM,
  article_number,
})
export const initializeCompareForm = (article_number) => ({
  type: INITIALIZE_COMPARE_FORM,
  article_number,
})

export const initializeCompareFormFulfilled = () => ({
  type: INITIALIZE_COMPARE_FORM_DONE,
})

export const checkCategoryProperties = (form, value) => ({
  type: CHECK_CATEGORY_PROPERTIES,
  form,
  value,
})
export const createProperty = (form, name_de, name_fr) => ({
  type: CREATE_PROPERTY,
  form,
  name_de,
  name_fr,
})
export const createPropertyFulfilled = () => ({ type: CREATE_PROPERTY_DONE })
export const createPropertyFailed = (errors) => ({
  type: CREATE_PROPERTY_FAILED,
  errors,
})

export const createPropertyValue = (form, value) => ({
  type: CREATE_PROPERTY_VALUE,
  form,
  value,
})
export const createPropertyValueFulfilled = () => ({
  type: CREATE_PROPERTY_VALUE_DONE,
})
export const createPropertyValueFailed = (errors) => ({
  type: CREATE_PROPERTY_VALUE_FAILED,
  errors,
})

export const loadImportProduct = (id) => ({ type: LOAD_IMPORT, id })
export const loadImportProductFailed = (errors) => ({
  type: LOAD_IMPORT_FAILED,
  errors,
})
export const loadImportProductFulfilled = (importProduct) => ({
  type: LOAD_IMPORT_DONE,
  importProduct,
})

export const loadProduct = (id) => ({ type: LOAD, id: id })
export const clearProduct = () => ({ type: CLEAR })
export const loadProductFulfilled = (product) => ({ type: LOAD_DONE, product })
export const loadProductFailed = (errors) => ({ type: LOAD_FAILED, errors })

export const createProduct = (formValues) => ({ type: CREATE, formValues })
export const createProductFulfilled = () => ({ type: CREATE_DONE })
export const createProductFailed = (errors) => ({ type: CREATE_FAILED, errors })

export const createFamily = (formValues) => ({
  type: CREATE_FAMILY,
  formValues,
})
export const createFamilyFulfilled = () => ({ type: CREATE_FAMILY_DONE })
export const createFamilyFailed = (errors) => ({
  type: CREATE_FAMILY_FAILED,
  errors,
})

export const disableForm = () => ({ type: DISABLE_FORM })

export const saveProduct = (formValues, initialValues, form) => ({
  type: SAVE,
  formValues,
  initialValues,
  form,
})
export const saveProductFulfilled = (formValues) => ({
  type: SAVE_DONE,
  formValues,
})
export const saveProductFailed = (formValues) => ({
  type: SAVE_FAILED,
  formValues,
})

export const deleteProduct = (id) => ({ type: DELETE, id })
export const deleteProductFulfilled = () => ({ type: DELETE_DONE })
export const deleteProductFailed = (errors) => ({ type: DELETE_FAILED, errors })

export const loadProducts = () => ({ type: LOAD_PRODUCTS })
export const loadProductsFulfilled = (products) => ({
  type: LOAD_PRODUCTS_DONE,
  products,
})
export const loadProductsFailed = (errors) => ({
  type: LOAD_PRODUCTS_FAILED,
  errors,
})
export const setProperties = (id, properties) => ({
  type: SET_PROPERTIES,
  id,
  properties,
})

export const loadShopProducts = () => ({ type: LOAD_SHOP_PRODUCTS })
export const loadShopProductsFulfilled = () => ({
  type: LOAD_SHOP_PRODUCTS_FULFILLED,
})

export const updateAllProducts = (id) => ({ type: UPDATE_ALL, id })
export const updateAllProductsFulfilled = () => ({ type: UPDATE_ALL_DONE })
export const updateAllProductsFailed = (errors) => ({
  type: UPDATE_ALL_FAILED,
  errors,
})

export const archiveAllProducts = (id) => ({ type: ARCHIVE_ALL, id })
export const archiveAllProductsFulfilled = () => ({ type: ARCHIVE_ALL_DONE })
export const archiveAllProductsFailed = (errors) => ({
  type: ARCHIVE_ALL_FAILED,
  errors,
})

const initialState = {
  productLoading: false,
  importProduct: {},
  product: {},
  formDisabled: false,
  productsLoading: true, // TODO: @andreas – I switched tis, because the ProductBrowser never got false otherwise, but ... why?
  products: [],
  fulfilledRequests: {
    importForm: [],
    compareForm: [],
  },
}

export const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_IMPORT_FORM:
      return { ...state, importFormInitializing: true }

    case INITIALIZE_IMPORT_FORM_DONE:
      return { ...state, importFormInitializing: false }

    case INITIALIZE_DETAIL_FORM:
      return { ...state, detailFormInitializing: true }

    case INITIALIZE_DETAIL_FORM_DONE:
      return { ...state, detailFormInitializing: false }

    case INITIALIZE_COMPARE_FORM:
      return { ...state, compareFormInitializing: true }

    case INITIALIZE_COMPARE_FORM_DONE:
      return { ...state, compareFormInitializing: false }

    case LOAD_IMPORT:
      return { ...state, importProductLoading: true }

    case LOAD_IMPORT_DONE:
      return {
        ...state,
        importProductLoading: false,
        importProduct: action.importProduct,
      }

    case LOAD_IMPORT_FAILED:
      return { ...state, importProductLoading: false }

    case DISABLE_FORM:
      return { ...state, productLoading: false, formDisabled: false }

    case SAVE:
      return { ...state, productSaving: true }

    case SAVE_DONE:
      return { ...state, productSaving: false }

    case LOAD:
      return { ...state, productLoading: true }

    case CLEAR:
      return { ...state, product: {} }

    case LOAD_DONE:
      return { ...state, productLoading: false, product: action.product }

    case LOAD_FAILED:
      return { ...state, productLoading: false }

    case LOAD_PRODUCTS:
      return { ...state, productsLoading: true }

    case LOAD_PRODUCTS_DONE:
      return { ...state, productsLoading: false, products: action.products }

    case LOAD_PRODUCTS_FAILED:
      return { ...state, productsLoading: false }

    case SET_PROPERTIES:
      const index = state.products.findIndex(
        (product) => product.id === action.id
      )
      if (!index) return state
      const changedProduct = { ...state.products[index], ...action.properties }
      return {
        ...state,
        products: [
          ...state.products.slice(0, index),
          changedProduct,
          ...state.products.slice(index + 1),
        ],
      }

    case CREATE_PROPERTY_DONE:
      return { ...state, createdProperty: action.createdProperty }

    default:
      return state
  }
}

export const createPropertyEpic = (action$, store) =>
  action$.ofType(CREATE_PROPERTY).mergeMap((action) =>
    post('/properties.json', {
      property: { name_de: action.name_de, name_fr: action.name_fr },
    }).mergeMap((result) => {
      if (result.ok) {
        return [
          arrayPush(action.form, 'properties', {
            property_id: result.body.id,
            property_value_id: -1,
            dragId: uuid.v4(),
          }),
          createPropertyFulfilled(),
          loadProperties(),
        ]
      } else {
        toast.error(I18n.t('action.properties/SAVE_PROPERTY_FAILED'))
        return [result.body && createPropertyFailed(result.body.errors)]
      }
    })
  )

export const createPropertyValueEpic = (action$, store) =>
  action$.ofType(CREATE_PROPERTY_VALUE).mergeMap((action) =>
    post('/property_values.json', {
      property_value: {
        property_id: action.value.property_id,
        value_de: action.value.value_de,
        value_fr: action.value.value_fr,
      },
    }).mergeMap((result) => {
      if (result.ok) {
        return [
          createPropertyValueFulfilled(),
          loadProperties(),
          change(
            action.form,
            `properties[${action.value.index}][property_value_id]`,
            result.body.id
          ),
        ]
      } else {
        toast.error(I18n.t('action.properties/SAVE_FAILED'))
        return [result.body && createPropertyValueFailed(result.body.errors)]
      }
    })
  )

export const checkCategoryPropertiesEpic = (action$, store) =>
  action$.ofType(CHECK_CATEGORY_PROPERTIES).mergeMap((action) => {
    const { categories } = store.getState().categories
    const productCategories = action.value
    let productProperties = store
      .getState()
      .form[action.form].values.properties.slice(0)

    // extract, flatten, unique and sort property ids from category
    const categoryProperties = productCategories.map((productCategory) => {
      const category = categories.find(
        (category) => category.id === productCategory
      )
      return category ? category.properties.map((property) => property.id) : []
    })
    const categoryPropertyIds = [].concat
      .apply([], categoryProperties)
      .filter((element, index, array) => array.indexOf(element) === index)
      .sort()

    // add category properties and mark them
    productProperties.forEach(
      (productProperty) => (productProperty.category = false)
    )
    categoryPropertyIds.forEach((propertyId) => {
      let productProperty = productProperties.find(
        (productProperty) => productProperty.property_id === propertyId
      )
      if (productProperty) productProperty.category = true
      else
        productProperties.unshift({
          property_id: propertyId,
          category: true,
          property_value_id: -1,
        })
    })
    return [change(action.form, 'properties', productProperties)]
  })

export const loadImportFormEpic = (action$, store) =>
  action$
    .ofType(INITIALIZE_IMPORT_FORM)
    .mergeMap((action) => [loadImportProduct(action.article_number)])

export const initializeImportFormEpic = (action$, store) =>
  action$.ofType(INITIALIZE_IMPORT_FORM).switchMap(() => {
    const expectedResults = [LOAD_IMPORT_DONE]
    return action$
      .filter((action) => expectedResults.includes(action.type))
      .mergeMap((result) => {
        const { importProduct } = store.getState().product
        const productProperties = importProduct.properties.map(
          (property, index) => ({ ...property, dragId: uuid.v4() })
        )
        if (!importProduct.wd_new) return [push('/de/admin/dashboard')]
        else
          return [
            initialize('product_import_form', {
              status: 'inactive',
              product_categories: [],
              keywords_de: [],
              keywords_fr: [],
              title_de: importProduct.wd_title,
              title_fr: importProduct.wd_title2,
              seo_description_de: '',
              seo_description_fr: '',
              imageIdList: [],
              downloadIdList: [],
              manualMediumIdDe: null,
              datasheetMediumIdDe: null,
              explodedMediumIdDe: null,
              manualMediumIdFr: null,
              datasheetMediumIdFr: null,
              explodedMediumIdFr: null,
              description_de: '',
              description_fr: '',
              toDos: [],
              new_todo_user_id: store.getState().user.currentUser.id,
              properties: productProperties,
              existing_property: -1,
              new_property_de: '',
              new_property_fr: '',
              new_text_de: '',
              new_text_fr: '',
              new_row: 'nothing',
              accessoryIds: [],
              productIds: [],
              editingProperty: -1,
              alwaysOnStock: false,
            }),
            { type: INITIALIZE_IMPORT_FORM_DONE },
          ]
      })
      .takeUntil(action$.ofType(INITIALIZE_IMPORT_FORM_DONE))
  })

export const copyImportFormEpic = (action$, store) =>
  action$
    .ofType(COPY_IMPORT_FORM)
    .mergeMap((action) => get('/products/' + action.article_number))
    .mergeMap((result) => {
      if (result.ok) {
        const product = result.body
        const { categories } = store.getState().categories
        const productCategories = product.product_categories
        let productProperties = product.product_properties.slice(0)

        // extract, flatten, unique and sort property ids from category
        const categoryProperties = productCategories.map((productCategory) => {
          const category = categories.find(
            (category) => category.id === productCategory.id
          )
          return category
            ? category.properties.map((property) => property.id)
            : []
        })
        const categoryPropertyIds = [].concat
          .apply([], categoryProperties)
          .filter((element, index, array) => array.indexOf(element) === index)
          .sort()

        // add category properties and mark them
        categoryPropertyIds.forEach((propertyId) => {
          let productProperty = productProperties.find(
            (productProperty) => productProperty.property_id === propertyId
          )
          if (productProperty) productProperty.category = true
          else
            productProperties.unshift({
              property_id: propertyId,
              category: true,
              property_value_id: -1,
            })
        })
        productProperties = productProperties.map(({ id, ...property }) => ({
          ...property,
          dragId: uuid.v4(),
        }))
        return [
          initialize('product_import_form', {
            status: 'inactive',
            product_categories: product.product_categories.map(
              (category) => category.id
            ),
            title_de: product.title_de,
            title_fr: product.title_fr,
            keywords_de: [],
            keywords_fr: [],
            seo_description_de: product.seo_description_de,
            seo_description_fr: product.seo_description_fr,
            imageIdList: product.assets.map((asset) => asset.id),
            downloadIdsDe: product.downloads_de || [],
            downloadIdsFr: product.downloads_fr || [],
            manualMediumIdDe: product.manual_asset_id_de,
            datasheetMediumIdDe: product.datasheet_asset_id_de,
            explodedMediumIdDe: product.exploded_diagram_asset_id_de,
            manualMediumIdFr: product.manual_asset_id_fr,
            datasheetMediumIdFr: product.datasheet_asset_id_fr,
            explodedMediumIdFr: product.exploded_diagram_asset_id_fr,
            description_de: product.description_de,
            description_fr: product.description_fr,
            toDos: [],
            new_todo_user_id: store.getState().user.currentUser.id,
            properties: productProperties,
            existing_property: -1,
            new_property_de: '',
            new_property_fr: '',
            new_text_de: '',
            new_text_fr: '',
            new_row: 'nothing',
            accessories: product.accessories,
            editingProperty: -1,
            alwaysOnStock: product.always_on_stock,
          }),
        ]
      } else {
        toast.error(I18n.t('action.product/LOAD_IMPORT_FAILED'))
        return []
      }
    })

export const loadDetailFormEpic = (action$, store) =>
  action$
    .ofType(INITIALIZE_DETAIL_FORM)
    .mergeMap((action) => [loadProduct(action.article_number)])

export const initializeDetailFormEpic = (action$, store) =>
  action$.ofType(INITIALIZE_DETAIL_FORM).mergeMap(() => {
    const expectedResults = [LOAD_DONE, categories.LOAD_DONE]
    return action$
      .filter((action) => expectedResults.includes(action.type))
      .mergeMap((result) => {
        // We need both the loaded product and the categories to be able to fill the form
        // If any of those is still loading, we can't do that and have to wait for FULFILLED
        if (
          store.getState().product.productLoading ||
          store.getState().categories.categoriesLoading
        )
          return []
        const { product } = store.getState().product
        const { categories } = store.getState().categories
        const productCategories = product.product_categories
        let productProperties = product.product_properties.slice(0)

        // extract, flatten, unique and sort property ids from category
        const categoryProperties = productCategories.map((productCategory) => {
          const category = categories.find(
            (category) => category.id === productCategory.id
          )
          return category
            ? category.properties.map((property) => property.id)
            : []
        })
        const categoryPropertyIds = [].concat
          .apply([], categoryProperties)
          .filter((element, index, array) => array.indexOf(element) === index)
          .sort()

        // add category properties and mark them
        categoryPropertyIds.forEach((propertyId) => {
          let productProperty = productProperties.find(
            (productProperty) => productProperty.property_id === propertyId
          )
          if (productProperty) productProperty.category = true
          else
            productProperties.unshift({
              property_id: propertyId,
              category: true,
              property_value_id: -1,
            })
        })
        productProperties = productProperties.map((property, index) => ({
          ...property,
          dragId: uuid.v4(),
        }))
        return [
          initialize('product_edit_form', {
            id: product.id,
            status: product.status,
            product_categories: product.product_categories.map(
              (category) => category.id
            ),
            keywords_de: product.keywords.filter(
              (keyword) => keyword.language === 'de'
            ),
            keywords_fr: product.keywords.filter(
              (keyword) => keyword.language === 'fr'
            ),
            title_de: product.title_de,
            title_fr: product.title_fr,
            seo_description_de: product.seo_description_de,
            seo_description_fr: product.seo_description_fr,
            imageIdList: product.assets.map((asset) => asset.id),
            downloadIdsDe: product.downloads_de || [],
            downloadIdsFr: product.downloads_fr || [],
            manualMediumIdDe: product.manual_asset_id_de,
            datasheetMediumIdDe: product.datasheet_asset_id_de,
            explodedMediumIdDe: product.exploded_diagram_asset_id_de,
            manualMediumIdFr: product.manual_asset_id_fr,
            datasheetMediumIdFr: product.datasheet_asset_id_fr,
            explodedMediumIdFr: product.exploded_diagram_asset_id_fr,
            description_de: product.description_de,
            description_fr: product.description_fr,
            toDos: product.to_dos,
            new_todo_user_id: store.getState().user.currentUser.id,
            properties: productProperties,
            selectablePropertyIds: product.selectable_property_ids,
            existing_property: -1,
            new_property_de: '',
            new_property_fr: '',
            new_text_de: '',
            new_text_fr: '',
            new_row: 'nothing',
            family_member_ids: product.family_member_ids,
            preferred_product_id: product.preferred_product_id,
            familyCriteriaPropertyIds: product.family_criteria_property_ids,
            accessories: product.accessories,
            editingProperty: -1,
            alwaysOnStock: product.always_on_stock,
            specialStock: product.special_stock,
            clearance: product.clearance,
          }),
          { type: INITIALIZE_DETAIL_FORM_DONE },
        ]
      })
      .takeUntil(action$.ofType(INITIALIZE_DETAIL_FORM_DONE))
  })

export const loadCompareFormEpic = (action$, store) =>
  action$
    .ofType(INITIALIZE_COMPARE_FORM)
    .mergeMap((action) => [
      loadImportProduct(action.article_number),
      loadProduct(action.article_number),
    ])

export const initializeCompareFormEpic = (action$, store) =>
  action$.ofType(INITIALIZE_COMPARE_FORM).mergeMap(() => {
    const expectedResults = [LOAD_IMPORT_DONE, LOAD_DONE, categories.LOAD_DONE]
    return action$
      .filter((action) => expectedResults.includes(action.type))
      .mergeMap((result) => {
        if (
          store.getState().product.productLoading ||
          store.getState().categories.categoriesLoading
        )
          return []

        const { product } = store.getState().product
        const { categories } = store.getState().categories
        const productCategories = product.product_categories
        let productProperties = product.product_properties.slice(0)

        // extract, flatten, unique and sort property ids from category
        const categoryProperties = productCategories.map((productCategory) => {
          const category = categories.find(
            (category) => category.id === productCategory.id
          )
          return category
            ? category.properties.map((property) => property.id)
            : []
        })
        const categoryPropertyIds = [].concat
          .apply([], categoryProperties)
          .filter((element, index, array) => array.indexOf(element) === index)
          .sort()

        // add category properties and mark them
        categoryPropertyIds.forEach((propertyId) => {
          let productProperty = productProperties.find(
            (productProperty) => productProperty.property_id === propertyId
          )
          if (productProperty) productProperty.category = true
          else
            productProperties.unshift({
              property_id: propertyId,
              category: true,
              property_value_id: -1,
            })
        })
        productProperties = productProperties.map((property, index) => ({
          ...property,
          dragId: uuid.v4(),
        }))
        return [
          initialize('product_compare_form', {
            id: product.id,
            status: product.status === 'archived' ? 'active' : product.status,
            product_categories: product.product_categories.map(
              (category) => category.id
            ),
            keywords_de: product.keywords.filter(
              (keyword) => keyword.language === 'de'
            ),
            keywords_fr: product.keywords.filter(
              (keyword) => keyword.language === 'fr'
            ),
            title_de: product.title_de,
            title_fr: product.title_fr,
            seo_description_de: product.seo_description_de,
            seo_description_fr: product.seo_description_fr,
            imageIdList: product.assets.map((asset) => asset.id),
            downloadIdsDe: product.downloads_de || [],
            downloadIdsFr: product.downloads_fr || [],
            manualMediumIdDe: product.manual_asset_id_de,
            datasheetMediumIdDe: product.datasheet_asset_id_de,
            explodedMediumIdDe: product.exploded_diagram_asset_id_de,
            manualMediumIdFr: product.manual_asset_id_fr,
            datasheetMediumIdFr: product.datasheet_asset_id_fr,
            explodedMediumIdFr: product.exploded_diagram_asset_id_fr,
            description_de: product.description_de,
            description_fr: product.description_fr,
            toDos: product.to_dos,
            new_todo_user_id: store.getState().user.currentUser.id,
            properties: productProperties,
            existing_property: -1,
            new_property_de: '',
            new_property_fr: '',
            new_text_de: '',
            new_text_fr: '',
            new_row: 'nothing',
            family_member_ids: product.family_member_ids,
            preferred_product_id: product.preferred_product_id,
            familyCriteriaPropertyIds: product.family_criteria_property_ids,
            accessories: product.accessories,
            editingProperty: -1,
            alwaysOnStock: product.always_on_stock,
            specialStock: product.special_stock,
            clearance: product.clearance,
          }),
          { type: INITIALIZE_COMPARE_FORM_DONE },
        ]
      })
      .takeUntil(action$.ofType(INITIALIZE_COMPARE_FORM_DONE))
  })

export const loadImportProductEpic = (action$, store) =>
  action$
    .ofType(LOAD_IMPORT)
    .mergeMap((action) => get('/import_products/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadImportProductFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.product/LOAD_IMPORT_FAILED'))
        return [result.body && loadImportProductFailed(result.body.errors)]
      }
    })

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/products/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadProductFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.product/LOAD_FAILED'))
        return [loadProductFailed(result.body)]
      }
    })

export const loadProductsEpic = (action$, store) =>
  action$
    .ofType(LOAD_PRODUCTS)
    .mergeMap((action) => get('/products.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadProductsFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.product/LOAD_PRODUCTS_FAILED'))
        return [result.body && loadProductsFailed(result.body.errors)]
      }
    })

export const loadShopProductsEpic = (action$, store) =>
  action$
    .ofType(LOAD_SHOP_PRODUCTS)
    .mergeMap(() => get('/products/shop_index.json'))
    .mergeMap(() => [loadShopProductsFulfilled()])

const prepareProductAttributes = (formValues, initialValues, product) => {
  const {
    status,
    description_de,
    description_fr,
    title_de,
    title_fr,
    manualMediumIdDe,
    datasheetMediumIdDe,
    explodedMediumIdDe,
    manualMediumIdFr,
    datasheetMediumIdFr,
    explodedMediumIdFr,
    toDos,
    imageIdList,
    downloadIdsDe,
    downloadIdsFr,
    product_categories,
    keywords_de,
    keywords_fr,
    properties,
    selectablePropertyIds,
    accessories,
    family_member_ids,
    seo_description_de,
    seo_description_fr,
    preferred_product_id,
    familyCriteriaPropertyIds,
    alwaysOnStock,
    specialStock,
    clearance,
  } = formValues

  const product_properties = properties
    .filter((prop) => prop.property_value_id > 0 || prop.property_id === 1)
    .map((prop) => {
      if (prop.property_id === 1)
        return {
          id: prop.id,
          property_value_attributes: {
            id: prop.property_value_id,
            property_id: 1,
            value_de: prop.value_de,
            value_fr: prop.value_fr,
          },
        }
      else return { id: prop.id, property_value_id: prop.property_value_id }
    })

  const product_category_ids = product_categories.map((id) => id)
  const asset_ids = imageIdList.map((asset_id) => asset_id)
  const to_dos_attributes = toDos
  const keywords = [
    ...keywords_de.map((kw) => ({ ...kw, language: 'de' })),
    ...keywords_fr.map((kw) => ({ ...kw, language: 'fr' })),
  ]

  const audit_comment = initialValues
    ? Object.keys(formValues)
        .map((key) =>
          isEqual(formValues[key], initialValues[key]) ? false : key
        )
        .filter((k) => k)
        .filter(
          (value) =>
            ![
              'editingProperty',
              'newAccessoryCategoryId',
              'new_todo_text',
            ].includes(value)
        )
        .map((value) => I18n.t(`log.product.${value}`))
        .join(', ')
    : I18n.t('log.product.imported')

  return {
    status,
    description_de,
    description_fr,
    title_de,
    title_fr,
    audit_comment,
    seo_description_de,
    seo_description_fr,
    manual_asset_id_de: manualMediumIdDe,
    datasheet_asset_id_de: datasheetMediumIdDe,
    exploded_diagram_asset_id_de: explodedMediumIdDe,
    manual_asset_id_fr: manualMediumIdFr,
    datasheet_asset_id_fr: datasheetMediumIdFr,
    exploded_diagram_asset_id_fr: explodedMediumIdFr,
    family_criteria_property_ids: familyCriteriaPropertyIds,
    always_on_stock: alwaysOnStock,
    product_category_ids,
    family_member_ids,
    asset_ids,
    downloads_de: downloadIdsDe,
    downloads_fr: downloadIdsFr,
    accessories,
    keywords,
    product_properties,
    selectable_property_ids: selectablePropertyIds,
    to_dos_attributes,
    preferred_product_id,
    special_stock: specialStock,
    clearance,
  }
}

export const createEpic = (action$, store) =>
  action$
    .ofType(CREATE)
    .mergeMap((action) =>
      post('/products.json', {
        product: Object.assign(
          {},
          prepareProductAttributes(action.formValues),
          {
            article_number: store.getState().product.importProduct
              .article_number,
          }
        ),
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.product/CREATE_DONE'))
        return [
          createProductFulfilled(),
          loadProducts(),
          loadShopProducts(),
          push('/de/admin/dashboard'),
        ]
      } else {
        toast.error(I18n.t('action.product/CREATE_FAILED'))
        return [result.body && createProductFailed(result.body.errors)]
      }
    })

export const createFamilyEpic = (action$, store) =>
  action$
    .ofType(CREATE_FAMILY)
    .mergeMap((action) =>
      post('/products.json', {
        product: Object.assign({}, action.formValues, {
          status: 'active',
          kind: 'family',
        }),
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.product/CREATE_FAMILY_DONE'))
        return [
          createFamilyFulfilled(),
          loadProducts(),
          loadShopProducts(),
          push(config.nodes.product + result.body.product.article_number),
        ]
      } else {
        toast.error(I18n.t('action.product/CREATE_FAMILY_FAILED'))
        return [result.body && createFamilyFailed(result.body.errors)]
      }
    })
export const saveProductEpic = (action$, store) =>
  action$.ofType(SAVE).mergeMap((action) => {
    const attributes = prepareProductAttributes(
      action.formValues,
      action.initialValues,
      store.getState().product.product
    )
    return put('/products/' + action.formValues.id, {
      product: attributes,
      update_wd_data: action.form === 'product_compare_form',
    }).mergeMap((result) => {
      const { body = {} } = result
      const { product = {} } = body
      console.debug('product::', { action, result })
      if (result.ok) {
        toast.success(I18n.t('action.product/SAVE_DONE'))
        return [
          saveProductFulfilled(),
          setProperties(action.formValues.id, {
            title_de: attributes.title_de,
            title_fr: attributes.title_fr,
            status: attributes.status,
          }),
          setDirtyFormState(false),
          loadShopProducts(),
          action.form === 'product_edit_form'
            ? initializeDetailForm(product.article_number)
            : push('/de/admin/dashboard'),
        ]
      } else {
        toast.error(I18n.t('action.product/SAVE_FAILED'))
        return [result.body && saveProductFailed(result.body.errors)]
      }
    })
  })

export const deleteEpic = (action$, store) =>
  action$
    .ofType(DELETE)
    .mergeMap((action) => del('/products/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        return [
          loadProducts(),
          push('/de/admin/products/product'),
          deleteProductFulfilled(result.body),
        ]
      } else {
        toast.error(I18n.t('action.product/DELETE_FAILED'))
        return [deleteProductFailed(result.body)]
      }
    })

export const updateAllEpic = (action$, store) =>
  action$
    .ofType(UPDATE_ALL)
    .mergeMap((action) => {
      return put('/products/accept_updates.json')
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.products/UPDATE_ALL_DONE'))
        return [updateAllProductsFulfilled(), loadProductState()]
      } else {
        toast.error(I18n.t('action.products/UPDATE_ALL_FAILED'))
        return [result.body && updateAllProductsFailed(result.body.errors)]
      }
    })

export const archiveAllEpic = (action$, store) =>
  action$
    .ofType(ARCHIVE_ALL)
    .mergeMap((action) => {
      return put('/products/accept_archives.json')
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.products/ARCHIVE_ALL_DOME'))
        return [archiveAllProductsFulfilled(), loadProductState()]
      } else {
        toast.error(I18n.t('action.products/ARCHIVE_ALL_FAILED'))
        return [result.body && archiveAllProductsFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/product.js